import React, {
  useEffect,
  useMemo,
  useState,
} from "react";
import axios from "axios";
import ClienteSchedaOperativa from "./ClienteSchedaOperativa";

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  "https://interventi.synology.me:5050";

const normalizza = (value) =>
  String(value || "")
    .trim()
    .toLocaleLowerCase("it");

const nuovoClienteVuoto = {
  nome: "",
  indirizzo: "",
  telefono: "",
  email: "",
  referente: "",
  codice_fiscale: "",
};

const ClienteAutocomplete = ({
  cliente,
  setCliente,
  indirizzo,
  setIndirizzo,
  telefono,
  setTelefono,
  email,
  setEmail,
  clienteId,
  setClienteId,
  setCodiceFiscale,
  setPartitaIva,
  onClienteCreato,
}) => {
  const [clienti, setClienti] = useState([]);
  const [menuAperto, setMenuAperto] =
    useState(false);
  const [caricamento, setCaricamento] =
    useState(true);
  const [errore, setErrore] = useState("");
  const [schedaAperta, setSchedaAperta] =
    useState(false);

  const [creazioneAperta, setCreazioneAperta] =
    useState(false);

  const [creazioneInCorso, setCreazioneInCorso] =
    useState(false);

  const [erroreCreazione, setErroreCreazione] =
    useState("");

  const [nuovoCliente, setNuovoCliente] =
    useState(nuovoClienteVuoto);

  const [
    clienteSelezionatoId,
    setClienteSelezionatoId,
  ] = useState(clienteId || null);

  useEffect(() => {
    const id = Number(clienteId);
    setClienteSelezionatoId(
      Number.isInteger(id) && id > 0 ? id : null
    );
  }, [clienteId]);

  const clienteIdAttivo =
    clienteId || clienteSelezionatoId;

  useEffect(() => {
    let attivo = true;

    const caricaClienti = async () => {
      setCaricamento(true);
      setErrore("");

      try {
        const token =
          localStorage.getItem("token");

        const response = await axios.get(
          `${API_BASE_URL}/clienti`,
          {
            headers: token
              ? {
                  Authorization:
                    `Bearer ${token}`,
                }
              : {},
            withCredentials: true,
          }
        );

        if (!attivo) return;

        const elenco = Array.isArray(response.data)
          ? [...response.data]
          : [];

        elenco.sort((a, b) =>
          String(a.nome || "").localeCompare(
            String(b.nome || ""),
            "it",
            {
              sensitivity: "base",
            }
          )
        );

        setClienti(elenco);
      } catch (error) {
        console.error(
          "Errore caricamento clienti:",
          error
        );

        if (attivo) {
          setErrore(
            error?.response?.data?.message ||
              error?.response?.data?.error ||
              "Impossibile caricare i clienti"
          );
        }
      } finally {
        if (attivo) {
          setCaricamento(false);
        }
      }
    };

    caricaClienti();

    return () => {
      attivo = false;
    };
  }, []);

  const risultati = useMemo(() => {
    const ricerca = normalizza(cliente);

    return clienti
      .filter((item) => {
        if (!ricerca) return true;

        const contenuto = [
          item.nome,
          item.indirizzo,
          item.telefono,
          item.email,
          item.referente,
        ]
          .map(normalizza)
          .join(" ");

        return contenuto.includes(ricerca);
      })
      .slice(0, 10);
  }, [cliente, clienti]);

  const clienteEsisteEsatto = useMemo(() => {
    const nome = normalizza(cliente);

    if (!nome) return false;

    return clienti.some(
      (item) =>
        normalizza(item.nome) === nome
    );
  }, [cliente, clienti]);

  const puoCreareCliente =
    String(cliente || "").trim().length >= 2 &&
    !clienteEsisteEsatto &&
    !clienteIdAttivo;

  const modificaCliente = (event) => {
    const value = event.target.value || "";

    setCliente(value);
    setMenuAperto(true);
    setSchedaAperta(false);
    setCreazioneAperta(false);
    setErroreCreazione("");

    setClienteSelezionatoId(null);

    if (typeof setClienteId === "function") {
      setClienteId(null);
    }
  };

  const selezionaCliente = (item) => {
    setCliente(item.nome || "");
    setIndirizzo(item.indirizzo || "");
    setTelefono(item.telefono || "");
    setEmail(item.email || "");

    if (typeof setCodiceFiscale === "function") {
      setCodiceFiscale(
        item.codice_fiscale ||
        item.codiceFiscale ||
        item.cf ||
        ""
      );
    }

    if (typeof setPartitaIva === "function") {
      setPartitaIva(
        item.piva ||
        item.partita_iva ||
        item.partitaIva ||
        ""
      );
    }

    const idSelezionato = Number(item.id);

    setClienteSelezionatoId(
      idSelezionato
    );

    if (typeof setClienteId === "function") {
      setClienteId(idSelezionato);
    }

    setMenuAperto(false);
    setCreazioneAperta(false);
    setErroreCreazione("");
  };

  const scollegaCliente = () => {
    setClienteSelezionatoId(null);

    if (typeof setClienteId === "function") {
      setClienteId(null);
    }

    setSchedaAperta(false);
    setCreazioneAperta(false);
    setMenuAperto(true);
  };

  const apriCreazioneCliente = () => {
    setNuovoCliente({
      ...nuovoClienteVuoto,
      nome: String(cliente || "").trim(),
      indirizzo: indirizzo || "",
      telefono: telefono || "",
      email: email || "",
    });

    setErroreCreazione("");
    setMenuAperto(false);
    setCreazioneAperta(true);
  };

  const modificaNuovoCliente = (
    campo,
    valore
  ) => {
    setNuovoCliente((prev) => ({
      ...prev,
      [campo]: valore,
    }));
  };

  const creaNuovoCliente = async () => {
    const nome = String(
      nuovoCliente.nome || ""
    ).trim();

    if (!nome) {
      setErroreCreazione(
        "Inserisci il nome del cliente."
      );
      return;
    }

    const esistente = clienti.find(
      (item) =>
        normalizza(item.nome) ===
        normalizza(nome)
    );

    if (esistente) {
      setErroreCreazione(
        "Esiste già un cliente con questo nome."
      );
      return;
    }

    setCreazioneInCorso(true);
    setErroreCreazione("");

    try {
      const token =
        localStorage.getItem("token");

      const formData = new FormData();

      Object.entries(nuovoCliente).forEach(
        ([campo, valore]) => {
          const testo = String(
            valore || ""
          ).trim();

          if (testo) {
            formData.append(campo, testo);
          }
        }
      );

      const response = await axios.post(
        `${API_BASE_URL}/clienti`,
        formData,
        {
          headers: token
            ? {
                Authorization:
                  `Bearer ${token}`,
              }
            : {},
          withCredentials: true,
        }
      );

      const creato = response.data;

      if (!creato?.id) {
        throw new Error(
          "Il server non ha restituito l'ID del cliente creato."
        );
      }

      setClienti((prev) => {
        const aggiornati = [
          ...prev.filter(
            (item) =>
              Number(item.id) !==
              Number(creato.id)
          ),
          creato,
        ];

        aggiornati.sort((a, b) =>
          String(a.nome || "").localeCompare(
            String(b.nome || ""),
            "it",
            {
              sensitivity: "base",
            }
          )
        );

        return aggiornati;
      });

      selezionaCliente(creato);

      if (typeof onClienteCreato === "function") {
        onClienteCreato(creato);
      }

      setNuovoCliente(
        nuovoClienteVuoto
      );
    } catch (error) {
      console.error(
        "Errore creazione cliente:",
        error
      );

      setErroreCreazione(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "Errore durante la creazione del cliente"
      );
    } finally {
      setCreazioneInCorso(false);
    }
  };

  return (
    <div>
      <input
        type="text"
        value={cliente ?? ""}
        onChange={modificaCliente}
        onFocus={() => {
          if (!clienteIdAttivo) {
            setMenuAperto(true);
          }
        }}
        placeholder="Cerca nome, indirizzo o telefono"
        autoComplete="off"
        style={{
          width: "100%",
          minWidth: 0,
          boxSizing: "border-box",
        }}
      />

      <div
        style={{
          marginTop: "7px",
          fontSize: "13px",
          fontWeight: 600,
        }}
      >
        {caricamento && (
          <span>
            Caricamento anagrafica…
          </span>
        )}

        {!caricamento && errore && (
          <span style={{ color: "#b00020" }}>
            Errore: {errore}
          </span>
        )}

        {!caricamento && !errore && (
          <span>
            AUTOCOMPLETE ATTIVO —{" "}
            {clienti.length} clienti caricati
          </span>
        )}
      </div>

      {menuAperto &&
        !clienteIdAttivo &&
        !caricamento &&
        !errore && (
          <div
            style={{
              marginTop: "7px",
              maxHeight: "300px",
              overflowY: "auto",
              border:
                "1px solid #b9c2cc",
              borderRadius: "8px",
              background: "#ffffff",
              boxShadow:
                "0 6px 18px rgba(0,0,0,0.15)",
            }}
          >
            {risultati.map((item) => (
              <button
                key={item.id}
                type="button"
                onMouseDown={(event) => {
                  event.preventDefault();
                  selezionaCliente(item);
                }}
                style={{
                  display: "block",
                  width: "100%",
                  padding: "11px 12px",
                  textAlign: "left",
                  border: 0,
                  borderBottom:
                    "1px solid #e7eaee",
                  background: "#ffffff",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: "14px",
                  }}
                >
                  {item.nome}
                </div>

                {item.indirizzo && (
                  <div
                    style={{
                      marginTop: "3px",
                      fontSize: "12px",
                      color: "#555",
                    }}
                  >
                    📍 {item.indirizzo}
                  </div>
                )}

                {item.telefono && (
                  <div
                    style={{
                      marginTop: "2px",
                      fontSize: "12px",
                      color: "#555",
                    }}
                  >
                    📞 {item.telefono}
                  </div>
                )}
              </button>
            ))}

            {risultati.length === 0 &&
              !puoCreareCliente && (
                <div
                  style={{
                    padding: "12px",
                    fontSize: "13px",
                  }}
                >
                  Nessun cliente trovato.
                </div>
              )}

            {puoCreareCliente && (
              <button
                type="button"
                onMouseDown={(event) => {
                  event.preventDefault();
                  apriCreazioneCliente();
                }}
                style={{
                  display: "block",
                  width: "100%",
                  padding: "12px",
                  border: 0,
                  borderTop:
                    risultati.length > 0
                      ? "1px solid #d7dde5"
                      : 0,
                  background: "#f6f8fa",
                  color: "#344054",
                  textAlign: "left",
                  cursor: "pointer",
                  fontWeight: 800,
                  fontSize: "13px",
                }}
              >
                + Crea nuovo cliente “
                {String(cliente || "").trim()}”
              </button>
            )}
          </div>
        )}

      {creazioneAperta && (
        <div
          style={{
            marginTop: "10px",
            padding: "14px",
            border:
              "1px solid #cbd5e1",
            borderRadius: "10px",
            background: "#f8fafc",
          }}
        >
          <div
            style={{
              marginBottom: "12px",
              fontWeight: 800,
              fontSize: "14px",
              color: "#334155",
            }}
          >
            Nuovo cliente
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(2, minmax(0, 1fr))",
              gap: "10px",
            }}
          >
            <div
              style={{
                gridColumn: "1 / -1",
              }}
            >
              <label>Nome cliente *</label>
              <input
                type="text"
                value={nuovoCliente.nome}
                onChange={(e) =>
                  modificaNuovoCliente(
                    "nome",
                    e.target.value
                  )
                }
              />
            </div>

            <div
              style={{
                gridColumn: "1 / -1",
              }}
            >
              <label>Indirizzo</label>
              <input
                type="text"
                value={
                  nuovoCliente.indirizzo
                }
                onChange={(e) =>
                  modificaNuovoCliente(
                    "indirizzo",
                    e.target.value
                  )
                }
              />
            </div>

            <div>
              <label>Telefono</label>
              <input
                type="text"
                value={
                  nuovoCliente.telefono
                }
                onChange={(e) =>
                  modificaNuovoCliente(
                    "telefono",
                    e.target.value
                  )
                }
              />
            </div>

            <div>
              <label>Email</label>
              <input
                type="email"
                value={nuovoCliente.email}
                onChange={(e) =>
                  modificaNuovoCliente(
                    "email",
                    e.target.value
                  )
                }
              />
            </div>

            <div>
              <label>Referente</label>
              <input
                type="text"
                value={
                  nuovoCliente.referente
                }
                onChange={(e) =>
                  modificaNuovoCliente(
                    "referente",
                    e.target.value
                  )
                }
              />
            </div>

            <div>
              <label>Codice fiscale</label>
              <input
                type="text"
                value={
                  nuovoCliente.codice_fiscale
                }
                onChange={(e) =>
                  modificaNuovoCliente(
                    "codice_fiscale",
                    e.target.value
                  )
                }
              />
            </div>
          </div>

          {erroreCreazione && (
            <div
              style={{
                marginTop: "10px",
                color: "#b42318",
                fontSize: "13px",
                fontWeight: 700,
              }}
            >
              {erroreCreazione}
            </div>
          )}

          <div
            style={{
              display: "flex",
              gap: "8px",
              marginTop: "14px",
            }}
          >
            <button
              type="button"
              className="btn"
              onClick={creaNuovoCliente}
              disabled={creazioneInCorso}
            >
              {creazioneInCorso
                ? "Creazione..."
                : "Crea e collega"}
            </button>

            <button
              type="button"
              onClick={() => {
                setCreazioneAperta(false);
                setErroreCreazione("");
                setMenuAperto(true);
              }}
              disabled={creazioneInCorso}
              style={{
                padding: "8px 12px",
                border:
                  "1px solid #cbd5e1",
                borderRadius: "7px",
                background: "#ffffff",
                cursor: "pointer",
              }}
            >
              Annulla
            </button>
          </div>
        </div>
      )}

      {clienteIdAttivo && (
        <div
          style={{
            display: "flex",
            gap: "8px",
            alignItems: "center",
            flexWrap: "wrap",
            marginTop: "9px",
          }}
        >
          <span
            style={{
              padding: "6px 10px",
              borderRadius: "999px",
              border:
                "1px solid #65b87b",
              background: "#e7f8ed",
              fontSize: "13px",
              fontWeight: 700,
            }}
          >
            ✓ Collegato all’anagrafica
          </span>

          <button
            type="button"
            onClick={() =>
              setSchedaAperta(true)
            }
            style={{
              padding: "7px 11px",
              border:
                "1px solid #2e6fa7",
              borderRadius: "7px",
              background: "#eaf4ff",
              color: "#174c78",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Storico cliente
          </button>

          <button
            type="button"
            onClick={scollegaCliente}
            style={{
              padding: "7px 11px",
              border:
                "1px solid #b5bcc3",
              borderRadius: "7px",
              background: "#fff",
              cursor: "pointer",
            }}
          >
            Scollega
          </button>
        </div>
      )}

      {schedaAperta &&
        clienteIdAttivo && (
          <ClienteSchedaOperativa
            clienteId={clienteIdAttivo}
            onClose={() =>
              setSchedaAperta(false)
            }
          />
        )}
    </div>
  );
};

export default ClienteAutocomplete;
